<template>
  <FormContainer>
    <template #title>Tuteur</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_84"
          v-model="nomTuteurEtablissementModel"
          label="Nom"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.nom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.nom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_NOM_NAIS"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInput
          id="field_85"
          v-model="prenomTuteurEtablissementModel"
          label="Prénom"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.prenom?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.prenom?.$messageErreurDirty!"
          hint="50 caractères maximum"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_PRENOM"
          :maxlength="50"
          deletable
          :readonly
        />
        <WrapperInputDate
          id="field_86"
          v-model="dateNaissanceTuteurEtablissementModel"
          label="Date de naissance"
          :required="meta.tutorat?.tuteurEntrepriseEmployeur?.dateNaissance?.$status === PropertyStatus.Required"
          :alertLabel="meta.tutorat?.tuteurEntrepriseEmployeur?.dateNaissance?.$messageErreurDirty!"
          :hint="HINT_DATE"
          class="col-9 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE_NAIS"
          deletable
          :readonly
        />
      </div>
      <div class="form__bloc">
        <WrapperCheckbox
          id="field_92"
          v-model="attestationTuteurCriteresEligibiliteModel"
          label="L'employeur atteste sur l'honneur que le tuteur répond à l'ensemble des critères d'éligibilité à cette fonction"
          :alertLabel="meta.tutorat?.attestationTuteurCriteresEligibilite?.$messageErreurDirty!"
          :readonly
          class="col-36"
          style="margin: -5px 0"
        />
        <WrapperCheckbox
          id="field_87"
          v-model="attestationTuteurTroisStagiairesModel"
          label="L'employeur atteste sur l'honneur que le tuteur ne soit pas responsable de plus de 3 stagiaires et pas plus de 2 stagiaires si le tuteur est également l'employeur"
          :alertLabel="meta.tutorat?.attestationTuteurTroisStagiaires?.$messageErreurDirty!"
          :readonly
          class="col-36"
          style="margin: -5px 0"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { useDemandePROAStore } from '../../../../useDemandePROAStore'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import {
    FormContainer,
    HINT_DATE,
    PLACEHOLDER_PRENOM,
    PLACEHOLDER_NOM_NAIS,
    PLACEHOLDER_DATE_NAIS,
  } from '@/features/interface/demande/shared'

  const store = useDemandePROAStore()
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const nomTuteurEtablissementModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseEmployeur.nom', true)
  const prenomTuteurEtablissementModel = setupFieldWithKey<string>('tutorat.tuteurEntrepriseEmployeur.prenom', true)
  const dateNaissanceTuteurEtablissementModel = setupFieldWithKey<string>(
    'tutorat.tuteurEntrepriseEmployeur.dateNaissance',
    true,
  )
  const attestationTuteurCriteresEligibiliteModel = setupFieldWithKey<boolean>(
    'tutorat.attestationTuteurCriteresEligibilite',
  )
  const attestationTuteurTroisStagiairesModel = setupFieldWithKey<boolean>('tutorat.attestationTuteurTroisStagiaires')
</script>
